import { render, staticRenderFns } from "./QAdminLogs.vue?vue&type=template&id=748cd340&"
import script from "./QAdminLogs.vue?vue&type=script&lang=js&"
export * from "./QAdminLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports